const API_BASE_URL = "https://api.aqueris.co.uk/api";

export default API_BASE_URL;
